<template>
    <div class="table">
         
        <!--考勤配置 -->
        <div class="container" style="width:95%;">
            <el-form ref="form" :model="form"  v-loading="loading" :rules="rules" label-width="110px">
                
                <el-form-item   prop="deptId" label="学校：">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="onDeptChange" style="width:230px;">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-divider content-position="left">学校信息配置</el-divider>
                <el-form-item prop="schoolName" label="学校名称：">
                    <el-input v-model="form.schoolName" maxlength="15" style="width:230px;"></el-input>
                </el-form-item>

                <el-form-item prop="phrase" label="校园短语：">
                    <el-input v-model="form.phrase" maxlength="14" style="width:230px;"></el-input>
                </el-form-item>

                <el-form-item label="校园LOGO：">
                    <el-upload 
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :auto-upload="true"
                        :on-success="handleAvatarLogoSuccess"
                        :before-upload="beforeAvatarLogoUpload">
                        <img v-if="logoImageUrl" :src="logoImageUrl" :style="{transform:'rotateZ('+deg+'deg)'}" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <el-form-item label="校园图片：">
                    <el-upload 
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :auto-upload="true"
                        :on-success="handleAvatarSchoolSuccess"
                        :before-upload="beforeAvatarSchoolUpload">
                        <img v-if="schoolImageUrl" :src="schoolImageUrl" :style="{transform:'rotateZ('+deg+'deg)'}" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                
                <el-divider content-position="left">学生综合素质报告信息配置</el-divider>
                <el-form-item prop="title" label="报告标题：">
                    <el-input v-model="form.title" maxlength="12" style="width:300px;"></el-input>
                </el-form-item>

                <el-form-item label="综评结果：">
                    <el-input v-model="form.excellent" type="number" style="width:80px;"></el-input>%为优、
                    <el-input v-model="form.good" type="number" style="width:80px;"></el-input>%为良、
                    <el-input v-model="form.pass" type="number" style="width:80px;"></el-input>%为合格（
                    <el-checkbox v-model="form.fuheCheck"></el-checkbox>根据复合分输出综评结果）。
                </el-form-item>

                <el-form-item label="背景颜色：">
                    <el-radio v-model="form.background" label="green">绿色</el-radio>
                    <el-radio v-model="form.background" label="blue">蓝色</el-radio>
                </el-form-item>

                <el-form-item label="发布日期：">
                    <el-date-picker
                        style="width: 300px"
                        v-model="form.releaseDate"
                        type="date"
                        placeholder="请输入发布日期"
                        format="yyyy年MM月dd日"
                        value-format="yyyy年MM月dd日"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="温馨提示：">
                    <el-input
                        type="textarea"
                        placeholder="非评语，班主任特别交代的话。如：假期期间不要到水库玩水，下学期开学日期为几月几日，等。"
                        :rows="10"
                        v-model="form.warmPrompt"
                        maxlength="1000"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>

                <el-form-item prop="" label="过程记录输出">
                    <el-Checkbox v-model="form.processRecordSwitch"></el-Checkbox>
                </el-form-item>

                <el-divider content-position="left">成绩转化率规则配置</el-divider>
                <el-form-item label="规则一：">
                     范围&nbsp;<el-select 
                            v-model="form.gradeName1"
                            multiple
                            collapse-tags
                            style="width:150px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in grades"
                                :key="item.gradeName"
                                :label="item.gradeName"
                                :value="item.gradeName">
                            </el-option>
                        </el-select>，
                        <el-select 
                            v-model="form.yxgt1"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in gts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.yxInput1" type="number" style="width:80px;"></el-input>&nbsp;评为优秀，
                        <el-select 
                            v-model="form.lhgt1"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in gts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.lhInput11" type="number" style="width:80px;"></el-input>&nbsp;与&nbsp;
                        <el-select 
                            v-model="form.lhlt1"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in lts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.lhInput12" type="number" style="width:80px;"></el-input>评为良好，
                        <el-select 
                            v-model="form.jggt1"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in gts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.jgInput11" type="number" style="width:80px;"></el-input>&nbsp;与&nbsp;
                        <el-select 
                            v-model="form.jglt1"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in lts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.jgInput12" type="number" style="width:80px;"></el-input>评为及格，
                        <el-select 
                            v-model="form.djglt1"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in lts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.djgInput11" type="number" style="width:80px;"></el-input>&nbsp;评为待及格。
                </el-form-item>
                <el-form-item label="规则二：">
                    范围&nbsp;<el-select 
                            v-model="form.gradeName2"
                            multiple
                            collapse-tags
                            style="width:150px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in grades"
                                :key="item.gradeName"
                                :label="item.gradeName"
                                :value="item.gradeName">
                            </el-option>
                        </el-select>，
                        <el-select 
                            v-model="form.yxgt2"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in gts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.yxInput2" type="number" style="width:80px;"></el-input>&nbsp;评为优秀，
                        <el-select 
                            v-model="form.lhgt2"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in gts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.lhInput21" type="number" style="width:80px;"></el-input>&nbsp;与&nbsp;
                        <el-select 
                            v-model="form.lhlt2"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in lts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.lhInput22" type="number" style="width:80px;"></el-input>评为良好，
                        <el-select 
                            v-model="form.jggt2"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in gts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.jgInput21" type="number" style="width:80px;"></el-input>&nbsp;与&nbsp;
                        <el-select 
                            v-model="form.jglt2"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in lts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.jgInput22" type="number" style="width:80px;"></el-input>评为及格，
                        <el-select 
                            v-model="form.djglt2"
                            collapse-tags
                            style="width:100px;"
                            placeholder="请选择">
                            <el-option  
                                v-for="item in lts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;<el-input v-model="form.djgInput21" type="number" style="width:80px;"></el-input>&nbsp;评为待及格。    
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:right">
                <el-button type="danger" @click="clearConfig()">清空配置</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
              
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import { MessageBox } from 'element-ui';

    export default {
        name:"",
        data(){
            return{
                loading: false,
                form:{
                    deptId:"",
                    logoImageUrl:"",
                    schoolImageUrl:"",

                    schoolName:"",
                    phrase:"",
                    title:"",
                    excellent:"",
                    good:"",
                    pass:"",
                    fuheCheck:false,
                    background:"green",
                    releaseDate:"",
                    warmPrompt:"",
                    processRecordSwitch:true,
                
                    gradeName1:"", // 规则1
                    yxgt1:"",
                    yxInput1:"",
                    lhgt1:"",
                    lhInput11:"",
                    lhlt1:"",
                    lhInput12:"",
                    jggt1:"",
                    jgInput11:"",
                    jglt1:"",
                    jgInput12:"",
                    djglt1:"",
                    djgInput11:"",

                    gradeName2:"", // 规则二
                    yxgt2:"",
                    yxInput2:"",
                    lhgt2:"",
                    lhInput21:"",
                    lhlt2:"",
                    lhInput22:"",
                    jggt2:"",
                    jgInput21:"",
                    jglt2:"",
                    jgInput22:"",
                    djglt2:"",
                    djgInput21:"",
                },
                depts:[],
                grades:[],
                gts:[{
                    id:'>',
                    name:'大于'
                },{
                    id:'>=',
                    name:'大于等于'
                }],
                lts:[{
                    id:'<',
                    name:'小于'
                },{
                    id:'<=',
                    name:'小于等于'
                }],
                uploadUrl:"",
                logoImageUrl: "",
                schoolImageUrl: "",
                deg:0,
                rules: {
                    schoolName: [
                        { required: true, message: '请输入学校名称', trigger: 'blur' }
                    ],
                    phrase: [
                        { required: true, message: '请输入校园短语', trigger: 'blur' }
                    ],
                    title: [
                        { required: true, message: '请输入报告标题', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
            this.getDeptData();
            this.uploadUrl=this.nameUploadImageUrl;
        },
        components: {
        },
        methods:{
            // 获取部门管理
            getDeptData(){
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                        this.getGrades();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 切换学校
            onDeptChange(){
                this.getData();
                this.getGrades();
            },
            // 根据条件获取当前界面数据
            getData(){
                this.clear(); // 清空数据
                let url  = this.studencomprehensiveConfigListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 渲染清空数据
                        let resultData=res.data;
                        // 渲染有数据值
                        for(let i=0;i<resultData.length;i++){
                            let obj=resultData[i];

                            if(obj.dictKey == 'school_key'){ // 学校
                                this.form.schoolName=obj.dictVal;
                            }else if(obj.dictKey == 'phrase_key'){ // 校训短语
                                this.form.phrase=obj.dictVal;
                            }else if(obj.dictKey == 'logo_key'){ // 校园LOGO
                                this.logoImageUrl=obj.dictVal;
                            }else if(obj.dictKey == 'image_key'){ // 校园图片
                                this.schoolImageUrl=obj.dictVal;
                            }else if(obj.dictKey == 'title_key'){ // 报告标题
                                this.form.title=obj.dictVal;
                            }else if(obj.dictKey == 'result_key'){ // 综评结果
                                let resultObj=JSON.parse(obj.dictVal);
                                this.form.excellent=resultObj.yx;
                                this.form.good=resultObj.lh;
                                this.form.pass=resultObj.hg;
                                this.form.fuheCheck=Boolean(resultObj.fuheCheck);
                            }else if(obj.dictKey == 'background_key'){ // 背景颜色
                                this.form.background=obj.dictVal;
                            }else if(obj.dictKey == 'releaseDate_key'){ // 发布日期
                                this.form.releaseDate=obj.dictVal;
                            }else if(obj.dictKey == 'warmPrompt_key'){ // 温馨提示
                                this.form.warmPrompt=obj.dictVal;
                            }else if(obj.dictKey == 'processRecordSwitch_key'){ // 过程记录输出
                                this.form.processRecordSwitch=Boolean(obj.dictVal);
                            }else if(obj.dictKey == 'scoreRule_key'){ // 成绩规则
                                let scoreRuleArr=JSON.parse(obj.dictVal);
                                for(let j=0;j<scoreRuleArr.length;j++){
                                    let scoreRuleObj=scoreRuleArr[j];
                                    if(j == 0){
                                        this.form.gradeName1=scoreRuleObj.gradeName;
                                        this.form.yxgt1=scoreRuleObj.yxgt;
                                        this.form.yxInput1=scoreRuleObj.yxInput;
                                        this.form.lhgt1=scoreRuleObj.lhgt;
                                        this.form.lhInput11=scoreRuleObj.lhgtInput;
                                        this.form.lhlt1=scoreRuleObj.lhlt;
                                        this.form.lhInput12=scoreRuleObj.lhltInput;
                                        this.form.jggt1=scoreRuleObj.jggt;
                                        this.form.jgInput11=scoreRuleObj.jggtInput;
                                        this.form.jglt1=scoreRuleObj.jglt;
                                        this.form.jgInput12=scoreRuleObj.jgltInput;
                                        this.form.djglt1=scoreRuleObj.djglt;
                                        this.form.djgInput11=scoreRuleObj.djgltInput;
                                    }else if(j == 1){
                                        this.form.gradeName2=scoreRuleObj.gradeName;
                                        this.form.yxgt2=scoreRuleObj.yxgt;
                                        this.form.yxInput2=scoreRuleObj.yxInput;
                                        this.form.lhgt2=scoreRuleObj.lhgt;
                                        this.form.lhInput21=scoreRuleObj.lhgtInput;
                                        this.form.lhlt2=scoreRuleObj.lhlt;
                                        this.form.lhInput22=scoreRuleObj.lhltInput;
                                        this.form.jggt2=scoreRuleObj.jggt;
                                        this.form.jgInput21=scoreRuleObj.jggtInput;
                                        this.form.jglt2=scoreRuleObj.jglt;
                                        this.form.jgInput22=scoreRuleObj.jgltInput;
                                        this.form.djglt2=scoreRuleObj.djglt;
                                        this.form.djgInput21=scoreRuleObj.djgltInput;
                                    }
                                }
                            }
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            //获取年级列表
            getGrades(){
                let url  = this.studencomprehensiveConfigGetGradeListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // console.log(JSON.stringify(res.data));
                        this.grades=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            // 清空配置
            clear(){ 
                this.logoImageUrl=""; 
                this.schoolImageUrl=""; 
                this.form.schoolName=""; 
                this.form.phrase=""; 
                this.form.logoImageUrl="";
                this.form.schoolImageUrl="";
                this.form.title="";  
                this.form.excellent="";
                this.form.good="";
                this.form.pass="";
                this.form.fuheCheck=false;
                this.form.background="green"; 
                this.form.releaseDate=""; 
                this.form.warmPrompt="";
                this.form.processRecordSwitch=false;
                this.form.gradeName1="";
                this.form.yxgt1="";
                this.form.yxInput1="";
                this.form.lhgt1="";
                this.form.lhInput11="";
                this.form.lhlt1="";
                this.form.lhInput12="";
                this.form.jggt1="";
                this.form.jgInput11="";
                this.form.jglt1="";
                this.form.jgInput12="";
                this.form.djglt1="";
                this.form.djgInput11=""; 
                this.form.gradeName2="";
                this.form.yxgt2="";
                this.form.yxInput2="";
                this.form.lhgt2="";
                this.form.lhInput21="";
                this.form.lhlt2="";
                this.form.lhInput22="";
                this.form.jggt2="";
                this.form.jgInput21="";
                this.form.jglt2="";
                this.form.jgInput22="";
                this.form.djglt2="";
                this.form.djgInput21="";   
            },
            // 保存
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true; // 正在保存中

                        let obj={};
                        // 学校名称
                        obj['school_key']=this.form.schoolName;
                        // 校园短语
                        obj['phrase_key']=this.form.phrase;
                        // 校园LOGO
                        obj['logo_key']=this.form.logoImageUrl;
                        // 校园图片
                        obj['image_key']=this.form.schoolImageUrl;
                        // 报告标题
                        obj['title_key']=this.form.title;
                        // 综评结果
                        let resultObj={};
                        resultObj['yx']=this.form.excellent;
                        resultObj['lh']=this.form.good;
                        resultObj['hg']=this.form.pass;
                        resultObj['fuheCheck']=this.form.fuheCheck;
                        obj['result_key']=JSON.stringify(resultObj);
                        // 背景颜色
                        obj['background_key']=this.getUndefinedToStr(this.form.background);
                        // 发布日期
                        obj['releaseDate_key']=this.form.releaseDate;
                        // 温馨提示
                        obj['warmPrompt_key']=this.form.warmPrompt;
                        // 过程记录输出
                        obj['processRecordSwitch_key']=this.form.processRecordSwitch;

                        // 成绩转换率规则配置
                        let scoreRuleArr=new Array();
                        // 规则1
                        let scoreRuleObj={};
                        scoreRuleObj['gradeName']=this.getUndefinedToStr(this.form.gradeName1);
                        // 优秀
                        scoreRuleObj['yxgt']=this.getUndefinedToStr(this.form.yxgt1);
                        scoreRuleObj['yxInput']=this.getUndefinedToStr(this.form.yxInput1);
                        // 良好
                        scoreRuleObj['lhgt']=this.getUndefinedToStr(this.form.lhgt1);
                        scoreRuleObj['lhgtInput']=this.getUndefinedToStr(this.form.lhInput11);
                        scoreRuleObj['lhlt']=this.getUndefinedToStr(this.form.lhlt1);
                        scoreRuleObj['lhltInput']=this.getUndefinedToStr(this.form.lhInput12);
                        // 及格
                        scoreRuleObj['jggt']=this.getUndefinedToStr(this.form.jggt1);
                        scoreRuleObj['jggtInput']=this.getUndefinedToStr(this.form.jgInput11);
                        scoreRuleObj['jglt']=this.getUndefinedToStr(this.form.jglt1);
                        scoreRuleObj['jgltInput']=this.getUndefinedToStr(this.form.jgInput12);
                        // 待及格
                        scoreRuleObj['djglt']=this.getUndefinedToStr(this.form.djglt1);
                        scoreRuleObj['djgltInput']=this.getUndefinedToStr(this.form.djgInput11);
                        scoreRuleArr.push(scoreRuleObj);

                        // 规则2
                        scoreRuleObj={};
                        scoreRuleObj['gradeName']=this.getUndefinedToStr(this.form.gradeName2);
                        // 优秀
                        scoreRuleObj['yxgt']=this.getUndefinedToStr(this.form.yxgt2);
                        scoreRuleObj['yxInput']=this.getUndefinedToStr(this.form.yxInput2);
                        // 良好
                        scoreRuleObj['lhgt']=this.getUndefinedToStr(this.form.lhgt2);
                        scoreRuleObj['lhgtInput']=this.getUndefinedToStr(this.form.lhInput21);
                        scoreRuleObj['lhlt']=this.getUndefinedToStr(this.form.lhlt1);
                        scoreRuleObj['lhltInput']=this.getUndefinedToStr(this.form.lhInput22);
                        // 及格
                        scoreRuleObj['jggt']=this.getUndefinedToStr(this.form.jggt2);
                        scoreRuleObj['jggtInput']=this.getUndefinedToStr(this.form.jgInput21);
                        scoreRuleObj['jglt']=this.getUndefinedToStr(this.form.jglt2);
                        scoreRuleObj['jgltInput']=this.getUndefinedToStr(this.form.jgInput22);
                        // 待及格
                        scoreRuleObj['djglt']=this.getUndefinedToStr(this.form.djglt2);
                        scoreRuleObj['djgltInput']=this.getUndefinedToStr(this.form.djgInput21);
                        scoreRuleArr.push(scoreRuleObj);
                        obj['scoreRule_key']=JSON.stringify(scoreRuleArr);

                        // console.log(JSON.stringify(obj));
                        // return;
                        let data = {
                            'deptId':this.form.deptId,
                            'data':JSON.stringify(obj)
                        };
                        this.apiPost(this.studencomprehensiveConfigSaveUrl, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            this.$commonFn.showTip(err,3);
                            this.loading=false;
                        });

                    }
                });
            },
            // 清空配置
            clearConfig(){
                 MessageBox.confirm('此操作将永久清空配置数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((resolve) => {
                    let url = this.studencomprehensiveConfigDeltUrl;
                    let data = {
                        deptId:this.form.deptId
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            this.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        this.$commonFn.showTip(err,3);
                    });
                }).catch(() => {
                });
            }, 
            // 校园logo图片上传
            handleAvatarLogoSuccess(res, file) {
                this.logoImageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarLogoUpload(file) {
                let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt2M = file.size / 1024 / 1024 < 8;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 8MB!');
                }
                if(isJPG && isLt2M){
                    let uploadForm=new FormData(); 
                    // 上传文件
                    uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, uploadForm).then((res) => {
                        if(res.data.status == 200){
                           console.log("校园logo上传路径："+res.data.data.localFile);
                           this.form.logoImageUrl=res.data.data.localFile;
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                    });
                }else{
                    return false;
                }
            },
            // 校园图片上传
            handleAvatarSchoolSuccess(res, file) {
                this.schoolImageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarSchoolUpload(file) {
                let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt2M = file.size / 1024 / 1024 < 20;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 20MB!');
                }
                if(isJPG && isLt2M){
                    let uploadForm=new FormData(); 
                    // 上传文件
                    uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, uploadForm).then((res) => {
                        if(res.data.status == 200){
                           console.log("校园图片上传路径："+res.data.data.localFile);
                           this.form.schoolImageUrl=res.data.data.localFile;
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                    });
                }else{
                    return false;
                }
            },
            // 旋转
            rotate(){
                this.deg += 90;
                if(this.deg >= 360){
                    this.deg = 0
                }
            },
            // 遇到undefined就返回空字符串
            getUndefinedToStr(val){
                if(val == undefined){
                    return "";
                }else{
                    return val;
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .avatar {
        width: 130px;
        height: 108px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/ReportConfig.vue